<div class="bg-primary-color soft--ends relative" style="overflow: hidden">
  <div class="cf wrapper push--bottom relative">
    <span class="icon icon-info icon--header-background"></span>
    <div class="col small_12" style="position: relative; z-index: 1">
      <h1
        class="tera primary-font push-half--bottom white"
        tabindex="0"
        id="main-content"
      >
        {{ pageTitle }}
      </h1>
      <p
        class="secondary-font alpha dark-grey-1 push--bottom white"
        tabindex="0"
      >
        {{ registerPageText }}
      </p>
    </div>
  </div>
  <div class="panel--opacity">&nbsp;</div>
</div>
<div class="wrapper wrap pb-120 soft--medium pull-up">
  <div class="card pl-3 pr-3 pt-3 pb-3 col-sm-9 col-md-8">
    <form
      [formGroup]="customerForm"
      autocomplete="off"
      class="col-sm-12 col-md-8"
      role="form"
      aria-label="registration form"
    >
      <div *ngIf="requiresFullRegistration">
        <div class="form-group">
          <label
            ><span aria-hidden="true" class="form-field-required-marker">
              *</span
            >
            First name</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="first_name"
            role="textbox"
            aria-label="first name input field"
          />
          <div
            *ngIf="submitted && form.first_name.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.first_name.errors.required" role="alert">
              First name is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            ><span aria-hidden="true" class="form-field-required-marker">
              *</span
            >
            Last name</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="last_name"
            role="textbox"
            aria-label="last name input field"
          />
          <div
            *ngIf="submitted && form.last_name.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.last_name.errors.required" role="alert">
              Last name is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <label
            ><span aria-hidden="true" class="form-field-required-marker">
              *</span
            >
            Contact number</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="mobile"
            role="textbox"
            aria-label="Contact number input field"
            maxlength="11"
          />
          <div *ngIf="submitted && form.mobile.errors" class="invalid-feedback">
            <div *ngIf="form.mobile.errors.required" role="alert">
              Contact number is required
            </div>
            <div *ngIf="form.mobile.errors.minlength" role="alert">
              Please enter a vaild contact number
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Address</label>
          <input
            type="text"
            class="form-control"
            formControlName="address1"
            role="textbox"
            aria-label="address 1 input field"
          />
          <div
            *ngIf="submitted && form.address1.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.address1.errors.required" role="alert">
              Address is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Address 2</label>
          <input
            type="text"
            class="form-control"
            formControlName="address2"
            role="textbox"
            aria-label="address 2 input field"
          />
          <div
            *ngIf="submitted && form.address2.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.address2.errors.required" role="alert">
              Address 2 is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Town</label>
          <input
            type="text"
            class="form-control"
            formControlName="address4"
            role="textbox"
            aria-label="Address 4 input field"
          />
          <div
            *ngIf="submitted && form.address4.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.address4.errors.required" role="alert">
              Town is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Country</label>
          <input
            type="text"
            class="form-control"
            formControlName="country"
            role="textbox"
            aria-label="Country input field"
          />
          <div
            *ngIf="submitted && form.country.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.country.errors.required" role="alert">
              Country is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Postcode</label>
          <input
            type="text"
            class="form-control"
            formControlName="postcode"
            role="textbox"
            aria-label="postcode input field"
          />
          <div
            *ngIf="submitted && form.postcode.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.postcode.errors.required" role="alert">
              Postcode is required
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          Email</label
        >
        <input
          type="text"
          class="form-control"
          formControlName="email"
          role="textbox"
          aria-label="email input field"
        />
        <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
          <div *ngIf="form.email.errors.required" role="alert">
            Email address is required
          </div>
          <div *ngIf="form.email.errors.mismatch" role="alert">
            Email address must match
          </div>
          <div
            *ngIf="form.email.errors.pattern && !form.email.errors.required"
            role="alert"
          >
            Email address invalid
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          Confirm email</label
        >
        <input
          type="text"
          class="form-control"
          formControlName="confirmEmail"
          role="textbox"
          aria-label="confirm email input field"
        />
        <div
          *ngIf="submitted && form.confirmEmail.errors"
          class="invalid-feedback"
        >
          <div *ngIf="form.confirmEmail.errors.required" role="alert">
            Email address is required
          </div>
          <div *ngIf="form.confirmEmail.errors.mismatch" role="alert">
            Email address must match
          </div>
          <div
            *ngIf="
              form.confirmEmail.errors.pattern &&
              !form.confirmEmail.errors.required
            "
            role="alert"
          >
            Email address invalid
          </div>
        </div>
      </div>

      <div *ngIf="allowsMembers">
        <div class="form-group">
          <label
            ><span aria-hidden="true" class="form-field-required-marker">
              *</span
            >
            Password</label
          >
          <input
            type="password"
            class="form-control"
            formControlName="password"
            autocomplete="new-password"
            role="textbox"
            aria-label="password input field"
          />
          <div
            *ngIf="submitted && form.password.errors"
            class="invalid-feedback"
          >
            <div *ngIf="form.password.errors.required" role="alert">
              Password is required
            </div>
          </div>
        </div>
      </div>

      <h2>{{ 'FORM.REGISTER.ADDITIONAL_HEADER' | translate }}</h2>
      <hr />
      <!-- Customer questions -->
      <div *ngFor="let question of customerQuestions">
        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'text_field'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >

          <input
            type="text"
            class="form-control"
            formControlName="{{ question.reference }}"
            role="textbox"
            attr.aria-label="{{ question.name }} input field"
          />
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }} is required
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'text_area'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <textarea
            class="form-control"
            formControlName="{{ question.reference }}"
            attr.aria-label="{{ question.name }} text area field"
          ></textarea>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }} is required
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'number'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <input
            type="search"
            class="form-control"
            formControlName="{{ question.reference }}"
            attr.aria-label="{{ question.name }} input field"
            (keypress)="keyPressNumberField($event)"
            maxlength="11"
          />
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }} is required
            </div>
          </div>
        </div>

        <div
          *ngIf="
            question.visible &&
            question.detail_type == 'select' &&
            question.id == bookingQuestionsConfig.schoolNameSelectionAccounts
          "
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <input
            list="question.reference"
            formControlName="{{ question.reference }}"
            class="form-control selectpicker"
            (change)="onQuestionChange()"
          />
          <datalist id="question.reference">
            <option
              *ngFor="let option of question.options"
              [value]="option.name"
            >
              {{ option.name }}
            </option>
          </datalist>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }}
              {{ 'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate }}
            </div>
            <div
              *ngIf="form[question.reference].errors.selectedSchoolErr"
              role="alert"
            >
              {{ form[question.reference].errors.selectedSchoolErr }}
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="
            question.visible &&
            question.detail_type == 'select' &&
            question.id != bookingQuestionsConfig.schoolNameSelectionAccounts
          "
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <select
            formControlName="{{ question.reference }}"
            [value]="-1"
            class="form-select"
            (change)="onQuestionChange()"
            attr.aria-label="{{ question.name }}"
          >
            <option></option>
            <option
              *ngFor="let option of question.options"
              [value]="option.name"
            >
              {{ option.name }}
            </option>
          </select>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }} is required
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'date'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <input
            matInput
            formControlName="{{ question.reference }}"
            [matDatepicker]="picker"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker> </mat-datepicker>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }} is required
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="row mt-4">
    <div class="col-6">
      <button type="button" class="btn btn-primary" (click)="routerGoBack()">
        {{ 'COMMON.BACK' | translate }}
      </button>
    </div>
    <div class="col-6">
      <button
        class="btn btn-primary float-right"
        type="button"
        (click)="onSubmit()"
      >
        {{ 'COMMON.REGISTER' | translate }}
      </button>
    </div>
  </div>
</div>
